export class Config {
    public static get BaseApiUrl(): string {
        return import.meta.env.VITE_BASE_API_URL || 'https://api.qa.faasbydelta.com';
    }
    public static get OktaIssuer(): string {
        return import.meta.env.VITE_OKTA_ISSUER || '';
    }
    public static get OktaClientId(): string {
        return import.meta.env.VITE_OKTA_CLIENT_ID || '';
    }
    public static get ApiRetries(): number {
        return import.meta.env.VITE_API_RETRIES || 3;
    }
    public static get ApiDelay(): number {
        return import.meta.env.VITE_API_DELAY || 500;
    }
    public static get SalesforceUrl(): string {
        return import.meta.env.VITE_SALESFORCE_URL || 'https://tbk--qa.sandbox.lightning.force.com';
    }
    public static get FullStoryOrganizationId(): string {
        return import.meta.env.VITE_FULL_STORY_ORGANIZATION_ID || '';
    }
    public static get Environment(): string {
        return import.meta.env.VITE_ENVIRONMENT || 'local';
    }
    public static get HoneybadgerKey(): string {
        return import.meta.env.VITE_HONEYBADGER_KEY || '';
    }
    public static get LaunchDarklyKey(): string {
        return import.meta.env.VITE_LAUNCH_DARKLY_KEY || '';
    }
}
